<template >
    <div class="modal fade" id="TermConditionModel" style="display: none;z-index: 1430;">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
                <div class="modal-header bg-transparent">
                    <button id="TermConditionModelClose" type="button" class="btn-close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body pb-5 px-sm-5 mx-50">
                    <h4 class="text-center">CANCELLATION & REFUNDS</h4>
                    <br><br>
                    <a href="#cancellation"> <strong>CANCELLATION & REFUNDS</strong></a>
                    <br><br>
                    Any and all visitors to our site, whether or not they are registered, shall be deemed <strong>"users"</strong> of the
                    Services and shall be subject to the TOS. After an individual user registers on the Site through the
                    process of creating subscription account, that user shall then become a <strong>"member"</strong>.
                    <br><br>
                    As a member”, you may completely terminate your account, associated email
                    address and access to our Services by providing the “<strong>Reason For Deactivation</strong>” then selecting the
                    “<strong>Deactivate</strong>” Account button. You can find this located under your “<strong>User Account Settings</strong>” section.
                    <br>
                    <br>
                    <strong id=“cancellation”>Refund Policy:</strong>
                    The Trial Period Price is for the {{ planStore.trialDays }} days only and plans renew at the regular rate. Your satisfaction is our top priortity and we’re
                    confident you’ll be pleased with our services. Still, if you try use and decide your account does not sufficiently meet your needs, you
                    can cancel within {{ planStore.trialDays }} days for a refund as follows:
                    <ul>
                    <li>
                    If “member” cancel within {{ planStore.trialDays }} days from the date of transaction you may receive a full refund on your service only.
                    The refund does not apply to add-on products, such as spin letters, given the unique nature of their costs.
                    </li>
                    <li>
                    If “member” cancel within {{ planStore.trialDays }} days and “member” has created a dispute letter, Creditfixrr will deduct a non-refundable
                    letter generation fee of $19.99 from your refund.
                    </li>
                    <li>
                    Creditfixrr does not offer any refunds for cancellations that occur after {{ planStore.trialDays }} days or after the Promotional Trial Period.
                    </li>
                    <li>
                    Creditfixrr does not offer any refunds for cancellations of annual subscription.
                    </li>
                    </ul>
                    <br>
                    <br>
                    Each user and member acknowledges and agrees that the Services provided and made available
                    through our website and applications, including mobile applications, applications that may be
                    made available on social media networking sites as well as other platforms and downloadable
                    programs, are the sole property of Creditfixrr Technology LLC. In the event that Creditfixrr Technology LLC. offers additional Services or products, or updates, modifies or revises its website,
                    applications, downloadable programs, content and Services, this Agreement shall remain effective
                    and shall continue to apply to all users and members for all existing and additional, updated,
                    modified or revised Services, products and applications. Creditfixrr Technology LLC. hereby
                    reserves the right to unilaterally cancel, terminate and cease offering any of its Services and
                    products at any time without prior or advanced notice. You, as a user or member, acknowledge,
                    accept and agree that you will not hold Creditfixrr Technology LLC. liable for any claims that you
                    have or hold, or may have or hold, that are related in any way to any update, modification,
                    revision, suspension termination or discontinuance of any of our Services or products. You further
                    agree that you will not assert any claims against Creditfixrr Technology LLC., whether by initiating
                    a lawsuit or through any other forum, related in any way to any update, modification, revision,
                    suspension termination or discontinuance of any of our Services or products and that you
                    expressly release Creditfixrr Technology LLC. from any such claims. Your continued use of the
                    website, applications and Services after any updates, changes, or modifications shall constitute
                    your acceptance of such updates, changes revisions, suspensions or modifications.
                    <br>
                    <br>
                    You acknowledge that Creditfixrr Technology LLC. may amend, update, modify or revise this TOS
                    without your prior notice or consent. As such, you acknowledge that you have reviewed this TOS
                    and you agree to carefully review any notices, amendments, updates, modifications or revisions
                    relating to it. If you do not agree to any amended, updated, revised or modified terms, you agree
                    to immediately stop using Creditfixrr Technology LLC's Services and products and to terminate
                    your membership.
                    <br>
                    <br>
                    Furthermore, users and members understand, acknowledge and agree that the Services and
                    products offered by Creditfixrr Technology LLC. shall be provided "AS IS" and as such Creditfixrr
                    Technology Inc. shall not assume any responsibility or obligation for the timeliness, missed delivery,
                    deletion or any failure to store user or member content, communication or personalization settings.
                    <br>
                    <br>
                    <button type="button" class="btn btn-outline-primary mt-1 modal-close-btn waves-effect float-end" data-dismiss="modal" aria-label="Close">Agree</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { usePlanStore } from '../../stores/PlanStore.js'
    export default{
        setup(props) {
            return {
                planStore: usePlanStore(),
            }
        },
        components: {},
        computed:{},
        created() {},
        mounted(){},
        methods: {},
    }
</script>
    